import Vue from 'vue';

function TreeGrid(data) {
  if (!(this instanceof TreeGrid)) {
    return new TreeGrid(data, null, null);
  }
}
TreeGrid.treeToArray = (data, parent, level, expandedAll) => {
  let tmp = [];
  if (!data || !data.length) return tmp;

  Array.from(data).forEach((record) => {
    if (record.priExpanded === undefined) {
      Vue.set(record, 'priExpanded', expandedAll);
    }
    if (level === 1) {
      Vue.set(record, 'priExpanded', !expandedAll);
    }
    if (parent) {
      Vue.set(record, 'priParent', parent);
    }
    let priLevel = 0;
    if (level !== undefined && level !== null) {
      priLevel = level + 1;
    }
    Vue.set(record, 'priLevel', priLevel);
    tmp.push(record);
    if (record.children && record.children.length > 0) {
      const children = TreeGrid.treeToArray(record.children, record, priLevel, expandedAll);
      tmp = tmp.concat(children);
    }
  });

  return tmp;
};

export default TreeGrid;
